export default function drawRoomTriangle(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  color: string,
) {
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.moveTo(x, y)
  ctx.lineTo(x - w, y)
  ctx.lineTo(x, y - h)
  ctx.closePath()
  ctx.fill()
}
